var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgColorFiller = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287 862 c-15 -15 -27 -32 -27 -37 0 -5 26 -35 57 -67 l58 -58 -150 -150 -150 -150 183 -183 182 -182 182 183 183 182 -245 245 -246 246 -27 -29z m273 -347 l115 -115 -235 0 -235 0 115 115 c63 63 117 115 120 115 3 0 57 -52 120 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778 298 c-84 -128 -75 -218 22 -218 85 0 104 71 47 174 -18 33 -38 61 -44 63 -6 2 -17 -7 -25 -19z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColorFiller, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/color-filler.e851dd60.svg";
export { ForwardRef as ReactComponent };